import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('GridSelect');

function GridSelect(props) {
    const selectOption = (ev, value) => {
        if (props.value !== value) {
            props.onChange(value);
        }
    };

    useEffect(() => {
        if (props.oneSizeLeft) {
            props.onChange(props.oneSizeLeft);
        }
    }, [props.partNumber]);

    const { className, hasError, name, options, type, value } = props;
    const errorClass = hasError ? 'selectWithError' : undefined;

    return (
        <ul className={bem(null, [errorClass, type], className)}>
            {options.map((opt) => {
                const htmlId = `${name}_${opt.key}`;
                return (
                    <li key={opt.key} className={bem('optionWrapper')}>
                        <input
                            checked={value === opt.value}
                            className={bem('input')}
                            htmlFor={htmlId}
                            name={name}
                            onChange={(ev) => selectOption(ev, opt.value)}
                            type="radio"
                        />
                        <label aria-label={opt.descriptiveLabel} className={bem('optionBox', opt.unavailable && 'unavailable')} id={htmlId}>
                            {opt?.onlyOneLeft && <div className={bem('onlyOneMark')} />}
                            {opt.label}
                        </label>
                        {opt.skuMetaData ? <meta content={opt.skuMetaData.partNumber} itemProp="sku" /> : null}{' '}
                        {/* product info for personal shopper chrome extension */}
                    </li>
                );
            })}
        </ul>
    );
}

GridSelect.propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    type: PropTypes.string,
    hasError: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    skus: PropTypes.array.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            key: PropTypes.string,
            label: PropTypes.string || PropTypes.node,
            labelNative: PropTypes.string,
        }),
    ),
};

export default GridSelect;
